import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(2),
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  backgroundColor:
    theme.palette.mode === "dark"
      ? theme.palette.grey[900]
      : theme.palette.background.paper,
  boxShadow: theme.shadows[8],
  position: "relative",
  zIndex: theme.zIndex.modal + 2,
  "& .MuiCircularProgress-root": {
    color: theme.palette.primary.main,
  },
}));
